import React, { useState } from "react";
import ImagePopupModal from "./ImagePopupModal";
import { getIcons } from "../../Constant/Constant";

const MemberDetailsModal = ({ selectedMember, closeModal }) => {
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [detailDisplay, setDetailDisplay] = useState(false);
  const icons = getIcons();

  if (!selectedMember) return null;

  const openImagePopup = (imageType) => {
    const imagePlaceholders = {
      aadhar: selectedMember?.aadhaarCardImageUrl,
      pan: selectedMember?.panCardImageUrl,
      passbook: selectedMember?.passbookImageUrl,
    };

    setCurrentImage({
      url: imagePlaceholders[imageType],
      type: imageType,
    });
    setShowImagePopup(true);
    setDetailDisplay(true);
  };

  const closeImagePopup = () => {
    setShowImagePopup(false);
    setCurrentImage(null);
    setDetailDisplay(false);
  };

  return (
    <>
      {!detailDisplay && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-[20px] p-[40px] w-[661px] mx-4">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="text-xl font-semibold">
                  User Name: {selectedMember.name}
                </h2>
                <p className="text-gray-600">
                  Onboard Date: {selectedMember.onBoardedDate}
                </p>
              </div>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 text-xl font-bold"
              >
                X
              </button>
            </div>

            <div className="mb-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-gray-700 font-medium">Name</p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    {selectedMember.name}
                  </div>
                </div>
                <div>
                  <p className="text-gray-700 font-medium">Phone Number</p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    {selectedMember.phoneNumber || "91xxxxxxxxx"}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-gray-700 font-medium">Email</p>
                  <div title={selectedMember?.emailId} className="bg-gray-100 cursor-pointer truncate p-3 rounded-md">
                    {selectedMember.emailId || "xxxx@gmail.com"}
                  </div>
                </div>
                <div>
                  <p className="text-gray-700 font-medium">
                    Alternate Phone Number
                  </p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    {selectedMember.alternatePhoneNumber || "91xxxxxxxxx"}
                  </div>
                </div>
              </div>
{/* 
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-gray-700 font-medium">Aadhar Card Image</p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    <a
                      onClick={
                        selectedMember?.aadhaarCardImageUrl
                          ? () => openImagePopup("aadhar")
                          : undefined}
                      className={` hover:underline ${
                        selectedMember?.aadhaarCardImageUrl
                          ? "cursor-pointer text-blue-500"
                          : "cursor-not-allowed text-red-500"
                      }`}
                    >
                      {selectedMember?.aadhaarCardImageUrl
                        ? "View Image"
                        : "No Image"}
                    </a>
                  </div>
                </div>
                <div>
                  <p className="text-gray-700 font-medium">Pan card Image</p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    <a
                      onClick={
                        selectedMember?.panCardImageUrl
                          ? () => openImagePopup("pan")
                          : undefined}
                      className={` hover:underline ${
                        selectedMember?.panCardImageUrl
                         ? "cursor-pointer text-blue-500"
                          : "cursor-not-allowed text-red-500"
                      }`}
                    >
                      {selectedMember?.panCardImageUrl
                        ? "View Image"
                        : "No Image"}
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <p className="text-gray-700 font-medium">Passbook Image</p>
                <div className="bg-gray-100 p-3 rounded-md">
                  <a
                    role="button"
                    onClick={
                      selectedMember?.passbookImageUrl
                        ? () => openImagePopup("passbook")
                        : undefined
                    }
                    className={` hover:underline ${
                      selectedMember?.passbookImageUrl
                       ? "cursor-pointer text-blue-500"
                          : "cursor-not-allowed text-red-500"
                    }`}
                  >
                    {selectedMember?.passbookImageUrl
                      ? "View Image"
                      : "No Image"}
                  </a>
                </div>
              </div> */}

              {selectedMember?.isParallelyWorking && (
                <div>
                  <p className="text-gray-700 font-medium">
                    Are you working for another company
                  </p>
                  <div className="bg-gray-100 p-3 rounded-md">
                    {selectedMember.parallelCompanies || "N/A"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <ImagePopupModal
        showModal={showImagePopup}
        imageData={currentImage}
        onClose={closeImagePopup}
      />
    </>
  );
};

export default MemberDetailsModal;
